import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dashboard-layout-root',
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.scss']
})
export class DashboardLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
